import { useEffect } from 'react'
import { Platform } from 'react-native'
import { useAuth } from '@/lib/auth'
import { log } from '@/lib/logger'
import { registerPushToken } from '@/lib/notifications'

export function usePushTokenRegistration() {
    const { user } = useAuth({ throwIfAnon: false })

    useEffect(() => {
        if (Platform.OS === 'web' || !user) return
        registerPushToken().catch(error => {
            log.warn('Push token registration failed silently:', error)
        })
    }, [user])
}
